import OrderTransportingOrderForwardingListRequest from "../../../../../api/raily/order/transporting-order/forwarding/list/order-transporting-order-forwarding-list.request";
import OrderTransportingOrderForwardingListParams from "./order-transporting-order-forwarding-list-params";

const create = (
  params: OrderTransportingOrderForwardingListParams,
): OrderTransportingOrderForwardingListRequest => {
  return {
    transportingOrderId: params.transportingOrderId,
  };
};

const orderTransportingOrderForwardingListParamsFactory = {
  create,
};

export default orderTransportingOrderForwardingListParamsFactory;
